import {createFileRoute} from '@tanstack/react-router'

import {zeroLevelIndexRoute} from "../../../../../utils/collectionListing";

export const Route = createFileRoute('/_site/users/_public_profile/notwant/$username/')({
    ...zeroLevelIndexRoute("/users/notwant/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName"),
});

